/*

sohel 10/14/2022 2700753823  Global Field -> Added Code Comments Changes
sohel 10/14/2022 2700753823  Global Field -> Added Code Comments
suresh 10/17/2022 2700753823 Design Enhancements in global Field Group, List.
ashraf 10/17/2022 2700753823 Added Global Field Ant tabs to landing page
ashraf 10/30/2022 2700753823 conditional tabs render
Prakash 11/23/2022  2700753823  Removed Card Component.
Sai maheshwar 11/28/2022  3031450488 rearranged global fields tabs
Ashraf 11/28/2022  3031450488 rearranged global fields tabs
Gummala Prakash 11/29/2022 3031450488 Removed Card Component.
Poornima 11/30/2022 3031450488  Repository Names tab renamed as Data Repository.
Rajesh 12/02/2022 2700753823 removed field list
Rohini 12/05/2022 2700753823  changed side nav format
Ashraf 12/05/2022 2700753823 Fixed header labels

*/

import Tabs from './Tabs';
import { useHistory, useLocation } from 'react-router';
import LandingPage from '../../../../Pages/LandingPage';
import React, { useContext, useEffect, useState } from 'react';
import SelectTabContextProvider from '../../../../components/SelectTabContext/SelectTabContext';

function GlobalField() {
  const history = useHistory();
  const location = useLocation();
  const [value, setValue] = React.useState(0);
  const [openTabLevel, setOpenTabLevel] = useState(false);
  const { sample, setNewTabValue } = useContext(SelectTabContextProvider);

  const handleChange = (event, newValue) => {
    if (sample && value === 2 && (newValue === 1 || newValue === 0)) {
      setOpenTabLevel(true);
      setNewTabValue(newValue);
    } else {
      setValue(newValue);
    }
  };
  const tabLabels = ['Data Repository', 'Repository Fields'];

  useEffect(() => {
    if (history.location.pathname === '/frameworks/data-repository/repository-fields') {
      setValue(1);
      setNewTabValue(1);
      setOpenTabLevel(false);
    }
  }, []);

  useEffect(() => {
    setValue(location?.state?.tabValue || 0);
  }, [location?.state?.tabValue]);

  return (
    // changed styles for dashboard(2700753823)
    <>
      <LandingPage
        title={'Data Management'}
        showTabs={true}
        tabValue={value}
        handleTabChange={handleChange}
        allAntTabs={tabLabels}
      >
        <div className={`global-field-dash-board`}>
          <div>
            <Tabs
              value={value}
              setValue={setValue}
              openTabLevel={openTabLevel}
              setOpenTabLevel={setOpenTabLevel}
            />
          </div>
        </div>
      </LandingPage>
    </>
  );
}

export default GlobalField;
